import React from 'react';
import Reflux from 'reflux';
import { Row, Col, Button } from 'bootstrap';
import Modal from 'shared/components/misc/modal.jsx';
import IntercomActions from 'flux/actions/IntercomActions';
import GlobalElementStore from 'flux/stores/GlobalElementStore';
import GlobalElementActions from 'flux/actions/GlobalElementActions';
import UIRegions from 'shared/constants/UIRegions';

/**
 * Migrate Global Element Categories to Labels Modal
 */
export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connect(GlobalElementStore, 'globalElements'),
  ],

  displayName: 'MigrateGlobalElementCategoriesToLabelsModal',

  render() {
    const { globalElements } = this.state;

    const teamId = globalElements.getIn(['team', '_id']),
      eventId = globalElements.getIn(['event', '_id']);

    return (
      <Modal
        headerClassName="ge-migration-modal__header"
        name={UIRegions.MigrateGloablElementSetCategoriesToLabelsModal}
        overrideHide
        display={globalElements.get('categoriesMigrationRequired')}
      >
        <Row className="ge-migration-modal">
          <Col md={24}>
            <img
              className="ge-migration-modal__image"
              src={`${window.shofloAssetBaseUrl}/img/geMultiTagSupport.png`}
            />
            <h1 className="ge-migration-modal__title">
              New & improved Global Elements!
            </h1>
            <p className="ge-migration-modal__description">
              We've made changes to the tag and categories functionality inside
              your Global Elements Manager. We're introducing the ability to add
              multiple tags per Global Element and as such, we are sunsetting
              categories. All categories will be converted to tags.
            </p>
          </Col>
          <Col className="ge-migration-modal__actions-wrapper" md={24}>
            <Button
              className="ge-migration-modal__button"
              onClick={() =>
                GlobalElementActions.migrateAllEventShowCategoriesToEventGlobalElementLabels(
                  teamId,
                  eventId,
                )
              }
            >
              {globalElements.get('categoriesMigrationInProgress')
                ? 'Working...'
                : 'Convert my categories to tags'}
            </Button>
          </Col>
          <Col className="ge-migration-modal__link-wrapper" md={24}>
            <a
              href="http://learn.shoflo.tv/global-element-basics/global-elements-update"
              target="_blank"
              className="ge-migration-modal__link"
            >
              Learn more
            </a>
          </Col>
          <Col className="ge-migration-modal__link-wrapper" md={24}>
            <a
              onClick={IntercomActions.categoriesMigration}
              className="ge-migration-modal__link"
            >
              Chat with a Shoflo Product Specialist first
            </a>
          </Col>
        </Row>
      </Modal>
    );
  },
});
